module.exports = __webpack_public_path__ + "media/images/ceremony/plans/2/hall-list/plan-ceremony-lineup-kanto-3-725d37411fffcba570a5f34e55f1203d.png";